<template>
  <div>
    <ion-list>
      <ion-item>
        <ion-label position="fixed">Title</ion-label>
        <ion-input placeholder="Title" v-ion-model="title" />
      </ion-item>

      <ion-item>
        <ion-label>Make this notebook <b>public</b>.</ion-label>
        <ion-toggle v-ion-model="isPublic"></ion-toggle>
      </ion-item>

      <ion-item class="notebook-select">
        <v-select label="label" :value="selectValue" @input="setSelected" :options="options" :searchable="false" :clearable="false" :appendToBody="true">
          <template #option="{ label, value, parent }">
            <div :class="value >= 1000 ? 'custom-categories' : 'default-categories'">
              <p v-if="parent" class="sub-categories">{{ label }}</p>
              <p v-else>{{ label }}</p>
            </div>
          </template>
        </v-select>
      </ion-item>

      <tiptap v-model="content"/>

    </ion-list>

    <div v-if="popupContent">
      <div id="popupMenu" style="display:none">
        <popup-menu></popup-menu>
      </div>
    </div>
  </div>
</template>
<script>

import Tiptap from '../../components/Editor.vue';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import marked from "marked";

export default {
  data() {
    return {
      id: "",
      title: "",
      content: "",
      isPublic: false,
      popupContent: false,
      config: {
        spellChecker: false,
        autofocus: true,
        hideIcons: ['image', 'guide', 'side-by-side']
      },
      options: [
        {label: 'Uncategorized', value: 1},
        {label: 'Political Law', value: 2},
        {label: 'Labor Law', value: 3},
        {label: 'Civil Law', value: 4},
        {label: 'Taxation Law', value: 5},
        {label: 'Commercial Law', value: 6},
        {label: 'Criminal Law', value: 7},
        {label: 'Remedial Law', value: 8},
        {label: 'Legal Ethics', value: 9},
        {label: 'Others', value: 10}
      ],
      category: 1
    };
  },

  computed: {
    textareaStyle() {
      return {
        resize: "none",
        "background-color": "transparent",
        "margin-top": "20px",
        "margin-bottom": "20px",
        border: "0px",
        outline: "none",
        "min-height": "500px",
        width: "calc(100% - 10px)"
      };
    },
    selectValue() {
      if(this.category) {
        const idx = this.options.findIndex(x => x.value === this.category);
        return this.options[idx];
      }
      return null;
    }
  },

  methods: {
    async load(id) {
      this.id = id;

      if (this.id) {
        var res = await this.$lawyerly.casebooks.view({
          id: this.id,
          docType: "note",
          docId: 0
        });
        if (res.data && res.data.count) {
          var note = res.data.result[0];
          this.title = note.title;
          this.content = marked(note.content);
          this.isPublic = note.public;
          this.category = note.category || 1;
        }
      }
    },

    async save() {
      if (!this.title) {
        this.$ionic.showToast("Please provide a title.", {
          position: "bottom"
        });
        return;
      }

      var res = {};

      if (!this.id) {
        // create
        res = await this.$lawyerly.casebooks.create({
          title: this.title,
          content: this.content,
          public: this.isPublic,
          category: this.category ? this.category : [],
          tags: []
        });
        if (res.data && res.data.id) {
          this.id = res.data.id;
          this.$router.replace("/notebooks/edit/" + this.id);
        }
      } else {
        // update
        res = await this.$lawyerly.casebooks.update({
          id: this.id,
          title: this.title,
          content: this.content,
          public: this.isPublic,
          category: this.category ? this.category : [],
          tags: []
        });
      }

      if (res.data && res.data.id) {
        this.$ionic.showToast("Saved.", {
          position: "bottom"
        });

        this.$router.replace("/notebooks/"+ res.data.id);
      } else {
        this.$ionic.showToast("Unable to save.", {
          position: "bottom"
        });
      }
    },

    resizeTextArea() {
      // try {
      //   var elm = this.$refs.content;
      //   elm.style.height = elm.scrollHeight + "px";
      // } catch (err) {
      //   //
      // }
    },

    onMore(evt) {
      this.popupContent = false; // re-create always
      setTimeout(() => {
        this.popupContent = true;
        this.$ionic.showPopover(evt, {
          template: "popupMenu",
          translucent: true
        });
      }, 200);
    },

    onHeaderCommand(event, cmd) {
      switch (cmd.cmd) {
        case "more":
          this.onMore(event);
          break;
        case "save":
          this.save();
          break;
      }
    },

    editorStyle() {
      return {
        width: '100%',
        marginTop: '8px'
      }
    },

    setSelected(value){
      if(value) {
        this.category = value.value;
      } else {
        this.category = null;
      }
        //  trigger a mutation, or dispatch an action  
    },

    async getCategories() {
      const res = await this.$http({
        method: "GET",
        url: this.$config.api.url + "/categories",
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        }
      });

      if(res) {
        if(res.data) {
          if(res.data.result.length > 0) {
            const categories = res.data.result;
            const opts = this.options;
            categories.forEach(el => {
              if(el.parent) {
                const idx = opts.findIndex(x => x.value === el.parent);
                opts.splice(idx+1, 0, {label: el.title, value: el.id, parent: el.parent});
              } else {
                opts.push({label: el.title, value: el.id});
              }
            });
          }
        }
      }
    }
  },

  mounted() {
    this.$ionic.dismissPopover();
    this.$store.commit("ui/setHeaderTitle", "Edit");
    this.load(this.$store.state.route.params.id);
    this.$store.commit("ui/setMoreHeaderButtons", {
      mobile: [
        { icon: "checkmark", emit: "header-command", cmd: "save" }
      ],
      web: [
        { label: "save", icon: "save", disabled: false, emit: "header-command", cmd: "save" },
      ]
    });
    this.$root.$on("header-command", this.onHeaderCommand);
    setTimeout(this.resizeTextArea, 500);
    this.getCategories();
  },

  beforeDestroy() {
    this.$store.commit("ui/setMoreHeaderButtons", {mobile: [], web: []});
    this.$store.commit("ui/setHeaderTitle", "");
    this.$root.$off("header-command", this.onHeaderCommand);
  },

  components: {
    Tiptap,
    "v-select": vSelect
  }
};
</script>
<style>

.notebook-select {
  max-width: 500px;
  padding: 0.5em;
  display: flex;
}

.v-select{
  flex: 1;
}

.vs__dropdown-option--highlight {
  background: var(--ion-color-primary);
}

.vs__dropdown-option {
  padding: 0.5em 0.5em;
}

.notebook-select a{
  color: var(--ion-color-primary);
  padding: 0.5em 1em;
  flex: 1;
  text-decoration: none;
}

.sub-categories {
  margin: 0 0 0 1.3em !important;
}

.default-categories p, .custom-categories p{
  margin: 0;
  padding-left: 0.5em;
}

.custom-categories p {
  border-left: 2px solid var(--ion-color-primary);
}
</style>
